import React, { useEffect, useState } from "react";
import { FileWarning, Trash2, Link2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import api, { fmtDate } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export default function DocumentiOrfaniPanel() {
  const { selectedStructure } = useAuth();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ospiti, setOspiti] = useState([]);
  const [operatori, setOperatori] = useState([]);
  const [sel, setSel] = useState({});
  const [busy, setBusy] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/documenti/orfani", { params: { structure_id: selectedStructure } });
      setDocs(r.data || []);
    } catch { toast.error("Errore nel caricamento documenti"); }
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [selectedStructure]);
  useEffect(() => {
    api.get("/ospiti", { params: { structure_id: selectedStructure, include_archiviati: true } }).then((r) => setOspiti(r.data || [])).catch(() => {});
    api.get("/firma/operatori", { params: { structure_id: selectedStructure } }).then((r) => setOperatori(r.data || [])).catch(() => {});
  }, [selectedStructure]);

  const elimina = async (d) => {
    if (!window.confirm("Archiviare (rimuovere) questo documento orfano?")) return;
    setBusy(d.id);
    try { await api.delete(`/documenti/${d.id}`); toast.success("Documento archiviato"); setDocs((p) => p.filter((x) => x.id !== d.id)); }
    catch { toast.error("Errore"); }
    setBusy(null);
  };
  const riassegna = async (d) => {
    const ownerId = sel[d.id];
    if (!ownerId) { toast.error("Seleziona a chi riassegnare"); return; }
    setBusy(d.id);
    try { const r = await api.put(`/documenti/${d.id}/riassegna`, { owner_id: ownerId }); toast.success(`Riassegnato a ${r.data.owner_nome}`); setDocs((p) => p.filter((x) => x.id !== d.id)); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
    setBusy(null);
  };

  const ownerList = (ot) => ot === "operatore"
    ? operatori.map((o) => ({ id: o.id, nome: `${o.nome} ${o.cognome}`.trim() }))
    : ospiti.map((o) => ({ id: o.id, nome: `${o.cognome} ${o.nome}`.trim() }));

  return (
    <div className="gr-card p-6 space-y-4" data-testid="documenti-orfani-card">
      <div className="flex items-center gap-2">
        <FileWarning size={20} className="text-amber-600" />
        <h2 className="font-head font-bold text-lg">Pulizia documenti orfani</h2>
        <Button variant="outline" size="sm" className="ml-auto" onClick={load} data-testid="orfani-refresh"><RefreshCw size={14} className="mr-1" /> Aggiorna</Button>
      </div>
      <p className="text-sm text-muted-foreground">Documenti collegati a un ospite o operatore non più presente in anagrafica. Puoi riassegnarli a un nominativo esistente oppure archiviarli.</p>
      {loading ? (
        <p className="text-sm text-muted-foreground">Caricamento…</p>
      ) : docs.length === 0 ? (
        <p className="text-sm text-emerald-700 font-medium" data-testid="orfani-empty">Nessun documento orfano: archivio pulito.</p>
      ) : (
        <div className="space-y-2" data-testid="orfani-list">
          {docs.map((d) => (
            <div key={d.id} className="border rounded-lg p-3 flex flex-col gap-2" data-testid={`orfano-${d.id}`}>
              <div className="min-w-0">
                <div className="font-semibold text-sm truncate">{d.titolo || d.original_filename}</div>
                <div className="text-xs text-muted-foreground">{d.categoria || "Documento"} · {d.owner_type === "operatore" ? "operatore" : "ospite"} · ultimo nome: <b>{d.owner_nome || "—"}</b>{d.created_at ? ` · ${fmtDate(String(d.created_at).slice(0, 10))}` : ""}</div>
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                <select className="h-9 border rounded-lg px-2 text-sm bg-white max-w-[220px]" value={sel[d.id] || ""} onChange={(e) => setSel((p) => ({ ...p, [d.id]: e.target.value }))} data-testid={`orfano-select-${d.id}`}>
                  <option value="">Riassegna a…</option>
                  {ownerList(d.owner_type).map((o) => <option key={o.id} value={o.id}>{o.nome}</option>)}
                </select>
                <Button size="sm" variant="outline" disabled={busy === d.id || !sel[d.id]} onClick={() => riassegna(d)} data-testid={`orfano-riassegna-${d.id}`}><Link2 size={14} className="mr-1" /> Riassegna</Button>
                <Button size="sm" variant="outline" className="text-destructive" disabled={busy === d.id} onClick={() => elimina(d)} data-testid={`orfano-elimina-${d.id}`}><Trash2 size={14} className="mr-1" /> Archivia</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
